import * as React from 'react'

export function CardsPage() {

  // ---------------------------------------------
  // Transformations
  // ---------------------------------------------
  // Render

  return (
    <div className={'cards-page'}>
      Cartões
    </div>
  )
}